import React, { Component } from 'react';

import SettingsCardHeader from '../SettingsCardHeader';

export default class ResultsContestView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            listExpanded: false
        }

        this.toggleExpanded = this.toggleExpanded.bind(this);

        this.pullTicket = this.pullTicket.bind(this);

        this.generateLineItem = this.generateLineItem.bind(this);

        this.generateContestItems = this.generateContestItems.bind(this);
        this.generateWinnerCard = this.generateWinnerCard.bind(this);
    }

    toggleExpanded() {
        this.setState({ listExpanded: !this.state.listExpanded })
    }

    pullTicket() {
        let winner = ""

        let hat = this.props.contestData.reduce((r, e) => {

            for (var i = 0; i < e.ticketCount; i++) {
                r.push(e.entityName);
            }

            return r;
        }, []);

        let hand = Math.floor(Math.random() * hat.length);
        winner = hat[hand];

        let self = this;
        zconfirm("Is " + winner + " a valid winner?", () => {
            self.props.setRaffleWinner(winner);
        });
    }

    generateLineItem(dat, isRanked) {
        let result = null;
        if (isRanked) {

            result = (
                <div className={"contest-result-outer"}>
                    <div className={"entity"}>{dat.entityName}</div>
                    <div className={"value"}>{dat.value.toFixed(0)}</div>
                </div>
            );
        } else {

            result = (
                <div className={"contest-result-outer"}>
                    <div className={"entity"}>{dat.entityName}</div>
                    <div className={"value"}>{dat.ticketCount}</div>
                </div>
            );
        }
        return result;
    }

    generateContestItems() {
        let self = this;

        let contest = this.props.activeContest;
        let contestData = this.props.contestData;

        let result = [];

        if (contestData.length <= 20 || this.state.listExpanded) {

            contestData.forEach(dat => {

                result.push(self.generateLineItem(dat, contest.rankedContestId != undefined))
            });
        } else {

            for (var i = 0; i < 10; i++) {
                result.push(self.generateLineItem(contestData[i], contest.rankedContestId != undefined))
            }

            result.push((
                <div className={"contest-result-outer tall"}>
                    <div className={"dots"}>{". . ."}</div>
                </div>
            ));

            for (var i = contestData.length - 10; i < contestData.length; i++) {
                result.push(self.generateLineItem(contestData[i], contest.rankedContestId != undefined))
            }
        }

        return result;
    }

    generateWinnerCard() {
        let result = null;

        if (this.props.activeContest.rankedContestId != undefined) {
            return result;
        }

        let text = this.props.activeContest.winner != null ? "Winner: " + this.props.activeContest.winner : "Draw Winner"

        result = (
            <div className={"settings-central-regular-card-container"}>
                <div className={"contest-winner"} onClick={this.pullTicket}>{text}</div>
            </div>
        )

        return result;
    }

    render() {

        if (this.props.contestData === undefined || this.props.contestData === null ||
            this.props.activeContest === undefined || this.props.activeContest === null) {
            return (
                <div className={this.props.className} style={this.props.style}>
                    <div className={"settings-central-regular-card-container"}>
                    </div>
                </div>
            );
        }

        let contestItems = this.generateContestItems();

        let winnerCard = this.generateWinnerCard();

        return (
            <div className={this.props.className} style={this.props.style}>
                {winnerCard}
                {this.props.contestData.length <= 20 ? null :
                    (<div className={"settings-central-regular-card-container"} onClick={this.toggleExpanded}>
                        <div className={"expand-button"}>{this.state.listExpanded ? "Show Highlights" : "Show All"}</div>
                    </div>)
                }
                <div className={"settings-central-regular-card-container"} style={{ lineHeight: 1 }}>
                    <SettingsCardHeader
                        title={this.props.activeContest.name}
                        subtitle={this.props.activeContest.description}
                    />
                    <div class="main-outer">
                        {contestItems}
                    </div>
                </div>
            </div>
        );
    }
}